// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1EGm0","head":"Table_head__1IqXu","col":"Table_col__92mHf"};